import { useMemo } from "react"
import { useSelector } from "react-redux"

import { getSpaces, getUser } from "~/store"
import { Space } from "~/types"

export function useJoinedSpace(): Space | undefined {
  const user = useSelector(getUser)
  const spaces = useSelector(getSpaces)

  return useMemo(
    () =>
      user?.space_name
        ? spaces.find((space) => space.name === user.space_name)
        : undefined,
    [spaces, user?.space_name],
  )
}
